/* Native Shopify country and language selection. No external geolocation service. */
(() => {
  'use strict';
  const countryLanguages = {
    DE:['de'],AT:['de'],CH:['de','fr','it'],FR:['fr'],ES:['es'],IT:['it'],
    BE:['fr','de'],LU:['fr','de'],IE:['en'],MT:['en'],UA:['uk']
  };
  function decideLocale(input) {
    const countries = new Set(input.countries || []);
    const languages = new Set(input.languages || []);
    const supportedCountry = value => typeof value === 'string' && countries.has(value);
    const supportedLanguage = value => typeof value === 'string' && languages.has(value);
    const country = supportedCountry(input.manualCountry) ? input.manualCountry
      : supportedCountry(input.detectedCountry) ? input.detectedCountry : input.currentCountry;
    let language = supportedLanguage(input.urlLanguage) ? input.urlLanguage
      : supportedLanguage(input.manualLanguage) ? input.manualLanguage : null;
    if (!language) {
      const choices = countryLanguages[country] || ['en'];
      const browser = String(input.browserLanguage || '').toLowerCase().split('-')[0];
      language = choices.includes(browser) && supportedLanguage(browser) ? browser
        : choices.find(supportedLanguage) || (languages.has('en') ? 'en' : input.currentLanguage);
    }
    return {country, language, requiresCountryConfirmation:!supportedCountry(input.manualCountry)};
  }
  if (typeof module === 'object' && module.exports) module.exports = {decideLocale};
  if (typeof window === 'undefined') return;
  const config = document.querySelector('[data-mp-localization]');
  const form = document.getElementById('MagicPosterLanguage');
  if (!config || !form) return;
  const countrySelect = form.querySelector('select[name="country_code"]');
  const languageSelect = form.querySelector('select[name="language_code"]');
  if (!countrySelect || !languageSelect) return;
  const countries = [...countrySelect.options].map(option=>option.value);
  const languages = [...languageSelect.options].map(option=>option.value);
  const details = form.closest('details');
  const summary = details?.querySelector('summary');
  const countryKey = 'magicposter-country-v2';
  const languageKey = 'magicposter-language-v1';
  let submitted = false;
  let manuallyChanged = false;
  const stored = (storage,key) => { try{return window[storage].getItem(key);}catch(_){return null;} };
  const save = (storage,key,value) => {try{window[storage].setItem(key,value);}catch(_){} };
  const readCookie = key => {
    const value = document.cookie.split('; ').find(part=>part.startsWith(key+'='));
    try{return value ? decodeURIComponent(value.slice(key.length+1)) : null;}catch(_){return null;}
  };
  const remember = (country,language) => {
    if(countries.includes(country)){
      save('localStorage',countryKey,country);
      document.cookie=`mp_market_country=${encodeURIComponent(country)}; Path=/; Max-Age=31536000; SameSite=Lax; Secure`;
    }
    if(languages.includes(language)){
      save('localStorage',languageKey,language);
      document.cookie=`mp_language=${encodeURIComponent(language)}; Path=/; Max-Age=31536000; SameSite=Lax; Secure`;
    }
  };
  const returnTo = (targetForm = form) => {
    const target = new URL(window.location.href);
    target.searchParams.delete('mp_lang_redirect');
    target.searchParams.delete('mp_country_test');
    let field=targetForm.querySelector('[name="return_to"]');
    if(!field){field=document.createElement('input');field.type='hidden';field.name='return_to';targetForm.appendChild(field);}
    field.value=target.pathname+target.search+target.hash;
  };
  form.addEventListener('change',()=>{manuallyChanged=true;});
  form.addEventListener('submit',()=>{
    submitted=true;manuallyChanged=true;remember(countrySelect.value,languageSelect.value);returnTo();
  });
  // Keep country choices made in Shopify's existing footer form too.
  document.addEventListener('submit',event=>{
    const other=event.target;
    if(!(other instanceof HTMLFormElement)||other===form||other.id==='MagicPosterWelcomeForm'||!other.querySelector('[name="form_type"][value="localization"]'))return;
    const country=other.querySelector('[name="country_code"]')?.value;
    const language=other.querySelector('[name="language_code"]')?.value;
    manuallyChanged=true;remember(country,language);
  },true);
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&details?.open){details.open=false;summary?.focus();}
  });
  document.addEventListener('click',event=>{
    if(details?.open&&!details.contains(event.target))details.open=false;
  });
  const url=new URL(window.location.href);
  const currentCountry=form.dataset.country;
  const currentLanguage=form.dataset.language;
  const prefix=url.pathname.split('/')[1].toLowerCase().split('-')[0];
  const urlLanguage=languages.includes(prefix)?prefix:null;
  const manualCountry=stored('localStorage',countryKey)||readCookie('mp_market_country');
  const manualLanguage=stored('localStorage',languageKey)||readCookie('mp_language');
  const preview=window.Shopify?.designMode||['unpublished','development'].includes(window.Shopify?.theme?.role)||url.searchParams.has('preview_theme_id');
  // This QA flag is ignored on the live storefront.
  const testWelcome=preview&&url.searchParams.get('mp_country_test')==='1';
  const rootElement=document.documentElement;
  const disabled=(preview&&!testWelcome)||config.dataset.pageType==='404'||/bot|crawler|spider|lighthouse/i.test(navigator.userAgent);
  if(disabled){rootElement.classList.remove('mp-country-pending');return;}
  if(countries.includes(manualCountry)&&!testWelcome){
    const choice=decideLocale({countries,languages,currentCountry,currentLanguage,manualCountry,manualLanguage,urlLanguage,browserLanguage:navigator.language});
    if(choice.country===currentCountry&&choice.language===currentLanguage){rootElement.classList.remove('mp-country-pending');return;}
    // Reapply an explicitly confirmed preference if Shopify's context differs.
    countrySelect.value=choice.country;languageSelect.value=choice.language;
    submitted=true;returnTo();HTMLFormElement.prototype.submit.call(form);return;
  }
  const welcome=document.getElementById('MagicPosterWelcome');
  const welcomeForm=document.getElementById('MagicPosterWelcomeForm');
  if(!welcome||!welcomeForm||typeof welcome.showModal!=='function'){
    rootElement.classList.remove('mp-country-pending');
    if(details)details.open=true;
    const hint=details?.querySelector('[data-country-hint]');if(hint)hint.hidden=false;
    return;
  }
  const welcomeCountry=welcomeForm.querySelector('[name="country_code"]');
  const welcomeLanguage=welcomeForm.querySelector('[name="language_code"]');
  let copy={};try{copy=JSON.parse(document.getElementById('MagicPosterWelcomeCopy')?.textContent||'{}');}catch(_){}
  let detectedCountry=null;
  let countryTouched=false;
  let languageTouched=false;
  const browserLanguage=String(navigator.language||'en').toLowerCase().split('-')[0];
  welcomeLanguage.value=urlLanguage||(languages.includes(manualLanguage)?manualLanguage:null)||(languages.includes(browserLanguage)?browserLanguage:currentLanguage);
  const updateCopy=()=>{
    const language=welcomeLanguage.value;
    const text=copy[language]||copy.en;
    if(!text)return;
    welcome.lang=language;
    welcome.querySelectorAll('[data-welcome-copy]').forEach(element=>{const value=text[element.dataset.welcomeCopy];if(value)element.textContent=value;});
    let names=null;try{names=new Intl.DisplayNames([language],{type:'region'});}catch(_){}
    [...welcomeCountry.options].forEach(option=>{
      if(option.value&&names)option.textContent=names.of(option.value)+' ('+option.dataset.currency+')';
    });
    const countryName=names?.of(detectedCountry||'DE')||[...welcomeCountry.options].find(option=>option.value===detectedCountry)?.textContent||detectedCountry;
    welcome.querySelector('#mp-country-detected').textContent=detectedCountry?text.detected.replace('{country}',countryName):text.unknown;
  };
  welcomeCountry.addEventListener('change',()=>{countryTouched=true;});
  welcomeLanguage.addEventListener('change',()=>{languageTouched=true;updateCopy();});
  welcome.addEventListener('cancel',event=>event.preventDefault());
  welcomeForm.addEventListener('submit',event=>{
    if(!countries.includes(welcomeCountry.value)||!languages.includes(welcomeLanguage.value)){event.preventDefault();return;}
    submitted=true;remember(welcomeCountry.value,welcomeLanguage.value);returnTo(welcomeForm);
    if(welcomeCountry.value===currentCountry&&welcomeLanguage.value===currentLanguage){
      event.preventDefault();welcome.close();rootElement.classList.remove('mp-country-pending');summary?.focus();
    }
  });
  updateCopy();rootElement.classList.add('mp-country-pending');welcome.showModal();
  const controller=new AbortController();
  const timeout=window.setTimeout(()=>controller.abort(),4000);
  const root=window.Shopify?.routes?.root||'/';
  fetch(root+'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true',{
    credentials:'same-origin',signal:controller.signal,headers:{Accept:'application/json'}
  }).then(response=>{if(!response.ok)throw new Error('Location unavailable');return response.json();})
    .then(data=>{
      if(submitted)return;
      const detected=data?.detected_values?.country?.handle;
      detectedCountry=countries.includes(detected)?detected:null;
      if(!countryTouched&&detectedCountry)welcomeCountry.value=detectedCountry;
      if(!languageTouched&&detectedCountry){
        welcomeLanguage.value=decideLocale({countries,languages,currentCountry,currentLanguage,manualLanguage,urlLanguage,detectedCountry,browserLanguage:navigator.language}).language;
      }
      updateCopy();
    }).catch(()=>{if(!submitted){detectedCountry=null;updateCopy();}})
    .finally(()=>window.clearTimeout(timeout));
})();
